module.exports = __webpack_public_path__ + "img/f5946ea.png";